import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import MobileNavigationTabs from "common/components/MobileNavigationTabs";
import usePageTitle from "common/hooks/usePageTitle";
import {
  ContentContainer,
  ContentHeader,
  ContentScroll,
  PageTitle,
} from "common/layouts/WorkspaceLayout";
import Banners from "common/layouts/WorkspaceLayout/Banners";
import SidebarNavigation from "common/layouts/WorkspaceLayout/DesktopLayout/SidebarNavigation";

import useSettingsNavItems from "../hooks/useSettingsNavItems";

import type { JSX } from "react";

export default function WorkspaceSettings() {
  const { pathname } = useLocation();
  const { navItems, routes } = useSettingsNavItems();
  const pageTitle = usePageTitle();

  let label: string, actionComponent: JSX.Element;

  let currentRoute = routes.find(({ path }) => path && pathname.includes(path));
  if (!currentRoute) {
    currentRoute = routes[0];
  }
  if (currentRoute) {
    if ("subNavItems" in currentRoute) {
      const subRoute = currentRoute.subNavItems.find(({ path: subRoutePath }) =>
        pathname.includes(subRoutePath),
      );
      if (subRoute) {
        label = `${subRoute.label} ${currentRoute.label.toLowerCase()}`;
        actionComponent = subRoute.actionComponent;
      }
    } else {
      label = currentRoute.label;
      actionComponent = currentRoute.actionComponent;
    }
  }

  return (
    <div className="flex gap-x-2 h-full grow">
      <SidebarNavigation title={pageTitle} navItems={navItems} />
      <div className="flex flex-col grow gap-y-1.5 max-w-full">
        <div className="max-lg:hidden">
          <Banners />
        </div>
        <ContentContainer>
          <ContentHeader className="lg:hidden">
            <PageTitle />
            {actionComponent}
          </ContentHeader>
          <ContentScroll className="p-4 lg:pt-20">
            <MobileNavigationTabs
              navItems={navItems}
              className="lg:hidden mb-6"
            />
            <div className="flex flex-col max-w-[808px] mx-auto w-full gap-y-4 flex-1">
              <div className="flex justify-between items-start mb-6 max-lg:hidden">
                <h2 className="text-lg-bold">{label}</h2>
                {actionComponent}
              </div>
              <Routes>
                {routes.map((route) => {
                  const { path } = route;
                  return (
                    <Route
                      key={path}
                      path={path}
                      element={"component" in route && route.component}
                    >
                      {"subNavItems" in route &&
                        route.subNavItems.map(
                          ({
                            path: subNavItemPath,
                            component: subNavItemComponent,
                          }) => (
                            <Route
                              key={`${path}-${subNavItemPath}`}
                              path={subNavItemPath}
                              element={subNavItemComponent}
                            />
                          ),
                        )}
                    </Route>
                  );
                })}
                <Route
                  path="*"
                  element={<Navigate to={routes[0].path} replace />}
                />
              </Routes>
            </div>
          </ContentScroll>
        </ContentContainer>
      </div>
    </div>
  );
}
